import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { LoggerStrategies } from '../constants/log';
import { Logger } from '../model/device/log.model';
import { PurchaseRequest } from '../model/http/google.model';
import { BannerAnalitycs } from '../model/local/banner.model';
import { GoogleLoggerStrategy } from './google-logger.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerManagerService implements Logger {

  private logger: Logger;
  constructor(
    private analyticsService: AngularFireAnalytics,
    private strategy: LoggerStrategies = LoggerStrategies.GOOGLE) {

    const dictStrategys: { [key: string]: Logger } = {
      GoogleStrategy: new GoogleLoggerStrategy(this.analyticsService),
    };
    this.logger = dictStrategys[this.strategy];
  }

  addToCar(): void {
    this.logger.addToCar();
  }
  exception(exceptionMessage: string, isFatal: boolean): void {
    this.logger.exception(exceptionMessage, isFatal);
  }
  purchase(purchaseData: PurchaseRequest): void {
    this.logger.purchase(purchaseData);
  }
  screenView(): void {
    this.logger.screenView();
  }
  bannerClick(data: BannerAnalitycs): void {
    this.logger.bannerClick(data);
  }
  configId(id: string): void {
    this.logger.configId(id);
  }

}
